import React from 'react';
import { Section } from './ui/Section';
export function HowItWorks() {
  const steps = [{
    num: '1',
    text: 'Descarga el protocolo e imprime tu Hoja de Emergencia S.O.S.'
  }, {
    num: '2',
    text: "Aplica el 'Ciclo 1-2' de sueño y la gestión de agua esa misma tarde."
  }, {
    num: '3',
    text: 'Sigue el protocolo de la primera noche y despierta en una casa limpia y silenciosa.'
  }];
  return <Section bg="white" data-id="element-100">
      <div className="text-center mb-16" data-id="element-101">
        <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-102">
          Cómo funciona
        </h2>
        <div className="w-24 h-1 bg-amber mx-auto rounded-full" data-id="element-103"></div>
      </div>

      <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-104">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 bg-cream-dark -z-10" data-id="element-105"></div>

        {steps.map((step, idx) => <div key={idx} className="relative flex flex-col items-center text-center" data-id="element-106">
            <div className="w-24 h-24 bg-cream rounded-full flex items-center justify-center border-4 border-white shadow-lg mb-6 z-10" data-id="element-107">
              <span className="font-serif text-4xl font-bold text-amber" data-id="element-108">
                {step.num}
              </span>
            </div>
            <p className="text-lg text-navy/80 font-medium px-4" data-id="element-109">{step.text}</p>
          </div>)}
      </div>
    </Section>;
}